import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { QueryBuilderLocalizationService } from 'src/app/shared/query-builder/query-builder-localization.service';
import { Dictionary } from 'src/app/core/model/dictionary';

/**
 * Angular executes an impure pipe during every component change detection cycle.
 * An impure pipe is called often, as often as every keystroke or mouse-move.
 */
@Pipe({ name: 'formlyRuleNarrative', pure: false })
export class FormlyRuleNarrativePipe implements PipeTransform
{
  constructor(
    private sanitized: DomSanitizer,
    private localService: QueryBuilderLocalizationService) { }

  public transform(dictionaries: any, item: any, args?: any): SafeHtml
  {
    let narrative = '';
    narrative += this.generateNarrative(dictionaries, item.rules, item.condition, args, 2, false);
    return this.sanitized.bypassSecurityTrustHtml(narrative);
  }

  private generateNarrative(dictionaries: any, ruleList, operator, config, depth, prependAnd)
  {
    let narrative = '';

    for (let ruleCount = 0; ruleCount < ruleList.length; ruleCount++)
    {
      const rule = ruleList[ruleCount];
      if (rule.rules && rule.rules.length > 0)
      {
        // recurse!
        narrative += this.generateNarrative(dictionaries, rule.rules, rule.condition, config, depth += 1, true);
        depth -= 1;
      }
      else
      {
        narrative += Array(depth).join('  ');
        if (prependAnd)
        {
          prependAnd = false;
        }

        if (rule.value === undefined) { rule.value = ''; } // avoid displaying 'undefined' when building a rule.

        const conf = this.parseConfig(dictionaries, config, rule);
        narrative += '<span class="narrative-text">' + conf.name + '</span> ';
        narrative += this.localService.getOperatorText(rule.operator);
        narrative += ' <span class="narrative-text">' + conf.display + '</span> ';

        // don't show the and/or operator for the last rule at this level
        if (this.showOperator(ruleCount, ruleList))
        {
          narrative += operator + '</br>';
        } else
        {
          narrative += '</br>';
        }
      }
    }
    return narrative;
  }

  private showOperator(ruleCount, ruleList): boolean
  {
    if (ruleList.length > ruleCount + 1)
    { // if we have more rules ahead
      const rule = ruleList[ruleCount + 1];
      if (rule.rules && rule.rules.length > 0)
      {
        return true;
      }
    }
    if (ruleList.length === ruleCount + 1)
    {
      return false;
    }
    return true;
  }

  private parseConfig(dictionaries: any, config: any, rule: any)
  {
    let display = rule.value;

    // gets display value based on what type this is.  (select box, etc.)
    let valuesArray = [];
    if (rule.value instanceof Array)
    {
      valuesArray = rule.value;
    }
    else
    {
      valuesArray.push(rule.value);
    }

    const configObj: any = {};
    const foundField = config.find(x => x.key === rule.field);
    if (foundField !== undefined)
    {
      const arraySeparator = '<br/>        ';

      // Set the display name or names
      let displayNames = '';
      valuesArray.forEach(d =>
      {
        const displayValueFound = foundField.templateOptions !== undefined &&
          foundField.templateOptions.options !== undefined ? foundField.templateOptions.options.filter(x => x.value === d) : [];
        if (displayValueFound.length === 1)
        {
          // For Array, options are listed on the next line
          if (rule.value instanceof Array)
          {
            displayNames += arraySeparator;
          }
          displayNames += displayValueFound[0].label;
        }
        else if (foundField.templateOptions && foundField.templateOptions.codeSetId)
        {
          const codeSet = dictionaries.get(foundField.templateOptions.codeSetId);
          if (codeSet) 
          {
            const dictionary = codeSet.find((x: Dictionary) => x.code === d);
            displayNames += arraySeparator;
            displayNames += dictionary ? dictionary.displayName : d;    // Use display name if found, otherwise use code
          }
        }
        if (displayNames !== '')
        {
          display = displayNames;
        }
      });
      configObj.name = foundField.templateOptions.label;
      configObj.type = foundField.type;
      configObj.display = display;
    }
    return configObj;
  }
}
